import { toast } from "react-toastify";
import { setAllPreloadedApi } from "../store/preloadedApisSlice";

const fetchAllData = async (dispatch, getLocations, setLoading=()=>{}) => {
  setLoading(true)
  try {  
    const result = await getLocations({ companyDetailID: 1 });    

    if (result?.data?.headers?.error !== 200) {
      toast.error(result?.data?.headers?.message || "Unknown error");   
      return null;
    } else {
      const transformedData = {
        locations:result?.data?.body?.items,
        courts: result?.data?.body?.items?.flatMap(location => location.courts),
        blockedSlots: [],
      };

      console.log("transformed Data", transformedData);
      dispatch(setAllPreloadedApi(transformedData));
      return transformedData;
    }
  } catch (err) {
    toast.error(new Error(err.message)?.message);
  }
  finally{
    setLoading(false)
  }
};

export default fetchAllData;
